import { css } from '@emotion/react';

const STAR_HEIGHT_RATIO = 22 / 16;
const STAR_SCALE = 1.4;

export const star = (size = 20) => css`
  display: inline-block;
  width: ${Math.round(size * STAR_SCALE)}px;
  height: ${Math.round(size * STAR_SCALE * STAR_HEIGHT_RATIO)}px;
`;
